// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_IRONING_AND_PACKING_INWARD_REQUEST = 'FETCH_IRONING_AND_PACKING_INWARD_REQUEST';
export const FETCH_IRONING_AND_PACKING_INWARD_SUCCESS = 'FETCH_IRONING_AND_PACKING_INWARD_SUCCESS';
export const FETCH_IRONING_AND_PACKING_INWARD_FAILURE = 'FETCH_IRONING_AND_PACKING_INWARD_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_IRONING_AND_PACKING_INWARD_REQUEST = 'CREATE_IRONING_AND_PACKING_INWARD_REQUEST';
export const CREATE_IRONING_AND_PACKING_INWARD_SUCCESS = 'CREATE_IRONING_AND_PACKING_INWARD_SUCCESS';
export const CREATE_IRONING_AND_PACKING_INWARD_FAILURE = 'CREATE_IRONING_AND_PACKING_INWARD_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_IRONING_AND_PACKING_INWARD = 'CREATE_USER_FORM_IRONING_AND_PACKING_INWARD';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_IRONING_AND_PACKING_INWARD_REQUEST = 'UPDATE_IRONING_AND_PACKING_INWARD_REQUEST';
export const UPDATE_IRONING_AND_PACKING_INWARD_SUCCESS = 'UPDATE_IRONING_AND_PACKING_INWARD_SUCCESS';
export const UPDATE_IRONING_AND_PACKING_INWARD_FAILURE = 'UPDATE_IRONING_AND_PACKING_INWARD_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_IRONING_AND_PACKING_INWARD_REQUEST = 'FETCH_SINGLE_IRONING_AND_PACKING_INWARD_REQUEST';
export const FETCH_SINGLE_IRONING_AND_PACKING_INWARD_SUCCESS = 'FETCH_SINGLE_IRONING_AND_PACKING_INWARD_SUCCESS';
export const FETCH_SINGLE_IRONING_AND_PACKING_INWARD_FAILURE = 'FETCH_SINGLE_IRONING_AND_PACKING_INWARD_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_IRONING_AND_PACKING_INWARD_REQUEST = 'DELETE_IRONING_AND_PACKING_INWARD_REQUEST';
export const DELETE_IRONING_AND_PACKING_INWARD_SUCCESS = 'DELETE_IRONING_AND_PACKING_INWARD_SUCCESS';
export const DELETE_IRONING_AND_PACKING_INWARD_FAILURE = 'DELETE_IRONING_AND_PACKING_INWARD_FAILURE';

export const FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_FAILURE';

// USERFORM RESET

export const IRONING_AND_PACKING_INWARD_USERFORM_RESET = 'IRONING_AND_PACKING_INWARD_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_IRONING_AND_PACKING_INWARD_DETAILS = 'NAVIGATE_IRONING_AND_PACKING_INWARD_DETAILS';
// navigate to company component
export const NAVIGATE_IRONING_AND_PACKING_INWARD = 'NAVIGATE_IRONING_AND_PACKING_INWARD';

export const SET_ACTIVE_KEY_IRONING_AND_PACKING_INWARD = 'SET_ACTIVE_KEY_IRONING_AND_PACKING_INWARD';
export const RESET_FORM_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID';

export const SET_UNIT_NAME_IRONING_AND_PACKING_INWARD = 'SET_UNIT_NAME_IRONING_AND_PACKING_INWARD';
export const SET_START_DATE_IRONING_AND_PACKING_INWARD = 'SET_START_DATE_IRONING_AND_PACKING_INWARD';
export const SET_END_DATE_IRONING_AND_PACKING_INWARD = 'SET_END_DATE_IRONING_AND_PACKING_INWARD';

export const FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_REQUEST = 'FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_REQUEST';
export const FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_SUCCESS = 'FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_SUCCESS';
export const FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_FAILURE = 'FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_FAILURE';

export const FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_REQUEST = 'FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_REQUEST';
export const FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_SUCCESS = 'FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_SUCCESS';
export const FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_FAILURE = 'FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_FAILURE';